import { ActivatedRouteSnapshot, DetachedRouteHandle, RouteReuseStrategy } from '@angular/router';
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class CustomReuseStrategy implements RouteReuseStrategy {
  // Map to store detached route handles (cached components)
  private storedRoutes = new Map<string, DetachedRouteHandle>();

  // Determines if the future route should reuse the current route
  shouldReuseRoute(future: ActivatedRouteSnapshot, curr: ActivatedRouteSnapshot): boolean {
    return future.routeConfig === curr.routeConfig;
  }

  // Determines if the route should be detached (cached)
  shouldDetach(route: ActivatedRouteSnapshot): boolean {
    const reusableRoutes = ['catalog', 'inventory', 'history', 'catalog-details/:id', 'inventory-details/:id', 'history-details/:id']; // Routes to cache
    return reusableRoutes.includes(route.routeConfig?.path || '');
  }

  // Stores the detached route handle for later reuse
  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle): void {
    if (route.routeConfig) {
      this.storedRoutes.set(route.routeConfig.path!, handle);
    }
  }

  // Determines if the route should be reattached (restored)
  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.storedRoutes.has(route.routeConfig?.path!);
  }

  // Retrieves the stored route handle to restore the component
  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.storedRoutes.get(route.routeConfig?.path!) || null;
  }

  // Call this on logout to clear all cached routes
  public clear(): void {
     console.log(this.storedRoutes.keys())
    // Remove all stored routes whose key starts with any reusable route template
    for (const key of Array.from(this.storedRoutes.keys())) {
      console.log(key);
      this.storedRoutes.delete(key);
    }
    console.log(this.storedRoutes.keys())
    console.log('Cleared all reusable routes from cache');
  }

  // Remove a specific route from cache
  public removeRoute(path: string): void {
    this.storedRoutes.delete(path);
    console.log(`Removed stored route: ${path}`);
  }

  private reusableRoutes = [
    'catalog',
    'inventory',
    'history',
    'catalog-details',
    'inventory-details',
    'history-details'
  ]; // Base route templates
}
